import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServicesTypesListComponent } from './services-types-list/services-types-list.component';
import { ServicesTypesDetailComponent } from './services-types-detail/services-types-detail.component';

const routes: Routes = [
    {
        path: 'servicesTypes',
        children: [
            { path: '', component: ServicesTypesListComponent }
        ]
    },
    {
        path: 'servicesTypes/:id',
        children: [
            { path: '', component: ServicesTypesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServicesTypesRoutingModule { }
